import Repository from '../axios'

export default {
  fetchObjectsList(object_name, filters = '') {
    return Repository.get(`/${object_name}/list?is_paginate=0&${filters}`)
  }
};
